import { debounce } from './utils/utils';

export default function () {
    const expandableSections = document.querySelectorAll(".text-expand-wrapper");

    expandableSections.forEach((section) => {
        checkIfEnable(section);

        window.addEventListener('resize', debounce(function () {
            let existingButton = section.querySelector('.expand-button');
            if (existingButton) existingButton.remove();
            checkIfEnable(section);
        }, 100));
    });
}

function checkIfEnable(section) {

    if (section.classList.contains('desc-wrapper')
        && section.parentElement.querySelector('.category-image')
        && window.innerWidth > 600) {
        return;
    }

    const cs = window.getComputedStyle(section);
    const maxHeight = +cs.getPropertyValue('--maxHeight').replace("px", "");
    const realHeight = section.querySelector("& > div").scrollHeight;
    if (realHeight <= maxHeight) return;

    initButton(section);
}

function initButton(section) {
    const buttonHTML = `<button class="expand-button" title="Rozwiń/zwiń sekcję"></button>`;
    section.insertAdjacentHTML("beforeend", buttonHTML);

    let button = section.querySelector('.expand-button');
    button.addEventListener('click', () => {
        section.classList.toggle('expanded');
    })
}